import { render } from "./PanelSetting.vue?vue&type=template&id=4ec19ba4&scoped=true"
import script from "./PanelSetting.vue?vue&type=script&lang=js"
export * from "./PanelSetting.vue?vue&type=script&lang=js"

import "./PanelSetting.vue?vue&type=style&index=0&id=4ec19ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec19ba4"]])

export default __exports__